import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  CostCenterPicker,
  ICostCenterProps,
} from '@work4all/components/lib/components/entity-picker/costCenter-Picker/CostCenterPicker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface CostCenterPickerFieldProps
  extends Omit<ICostCenterProps<false>, 'multiple'> {
  error?: string;
  label?: string;
  disabled?: boolean;
}

export const CostCenterPickerField = React.forwardRef<
  HTMLDivElement,
  CostCenterPickerFieldProps
>(function CostCenterPickerField(props, ref) {
  const { error, label, disabled, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  return (
    <EntityPickerPopover
      disabled={disabled}
      picker={<CostCenterPicker {...pickerProps} multiple={false} />}
    >
      <PickerTargetButton
        ref={ref}
        disabled={disabled}
        value={value?.name ?? ''}
        label={label || t('COMMON.COST_CENTER')}
        error={error}
        onClear={() => {
          onChange(null);
        }}
      />
    </EntityPickerPopover>
  );
});
